import { Routes } from "@angular/router";
import { AuthenticateComponent } from "./components/authenticate/authenticate.component";
import { AuthorizeComponent } from "./components/authorize/authorize.component";
import { LogoutComponent } from "./components/logout/logout.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { AuthGuard } from "./_helper/auth.gard";
import { RouterLanguageGaurdGuard } from "./_helper/router-language-gaurd.guard";
import { AuthRedirectGuard } from "./_helper/auth.redirect.guard";

export const routes: Routes = [
  {
    path: "",
    canActivate: [AuthRedirectGuard],
    component: AuthenticateComponent,
  },
  {
    path: "auth",
    component: AuthenticateComponent,
  },
  {
    path: "logout",
    component: LogoutComponent,
  },
  {
    path: "login",
    component: AuthorizeComponent,
  },
  {
    path: "events",
    children: [
      {
        path: "**",
        children: [],
        canActivate: [RouterLanguageGaurdGuard],
      },
    ],
    canActivate: [RouterLanguageGaurdGuard],
  },
  {
    path: "profile",
    children: [
      {
        path: "**",
        children: [],
        canActivate: [RouterLanguageGaurdGuard],
      },
    ],
    canActivate: [RouterLanguageGaurdGuard],
  },
  {
    path: ":languageId/profile",
    loadChildren: () =>
      import("./modules/alias/profile-routing.module").then((m) => m.routes),
    canMatch: [AuthGuard],
  },
  {
    path: ":languageId/events",
    loadChildren: () =>
      import("./modules/events/events-routing.module").then((m) => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: ":languageId/locations",
    loadChildren: () =>
      import("./modules/gmap/gmap-routing.module").then((m) => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];
